import { FileCardStyle, FileContainer } from './style';
import { LuGripVertical } from 'react-icons/lu';
import { SHEET_ROW_HEIGHT } from '../../utils';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
import { Box, Tooltip } from '@mantine/core';
import { TbFile, TbFiles } from 'react-icons/tb';
import { createStyles } from '@mantine/emotion';

const useStyles = createStyles(() => ({
  uploadType: {
    borderRadius: '4px',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4
  }
}));

export function EmptyFileCard({
  isOpenSheet,
  showDrag = false,
  isMultiUpload,
  dragProps,
  extraRows,
  isLoading,
  isCustomReportType
}) {
  const { classes } = useStyles();

  return (
    <FileContainer key={'isDisableAddingOn'}>
      <FileCardStyle>
        {showDrag ? (
          <button aria-label="Drag empty file card" {...dragProps}>
            <LuGripVertical fontSize="20px" color="#C1C2C5" />
          </button>
        ) : (
          <Box w={21.5} />
        )}

        <div className="file-box">
          <div className="file-name">
            <p>Current File does not exist</p>
            {!isCustomReportType && (
              <Tooltip label={isMultiUpload ? 'Multi-Upload' : 'Single-Upload'}>
                <Box className={classes.uploadType} bg="#F1F3F5">
                  {isMultiUpload ? (
                    <TbFiles size={16} color="#5C5F66" />
                  ) : (
                    <TbFile size={16} color="#5C5F66" />
                  )}
                </Box>
              </Tooltip>
            )}
          </div>
        </div>
      </FileCardStyle>

      {!isLoading && isOpenSheet && (
        <div className="sheets">
          {Array(extraRows)
            .fill()
            .map((_, index) => (
              <EmptyRow key={'extra_row' + index} />
            ))}
        </div>
      )}

      {isLoading && (
        <div className="sheets">
          {Array(extraRows)
            .fill()
            .map((_, index) => (
              <StyledSkeleton key={'extra_row' + index} height={SHEET_ROW_HEIGHT} width="220px" />
            ))}
        </div>
      )}
    </FileContainer>
  );
}

const StyledSkeleton = styled(Skeleton)`
  margin-left: 99px;
  opacity: 0.5;
`;

const EmptyRow = styled.div`
  width: 100%;
  height: ${SHEET_ROW_HEIGHT}px;
`;
